<script setup lang="ts">
const props = defineProps<{
  groupType: LocationGroupType
  label: string
}>()

const { groupBy } = useMapState()!

function set() {
  groupBy.value = props.groupType
}

const active = computed(() => groupBy.value === props.groupType)

const variant = computed(() => {
  return active.value ? 'solid' : 'subtle'
})
</script>

<template>
  <UButton :label="props.label" :active="active" :variant="variant" size="xs" @click="set" />
</template>
